export const SET_QUERY = 'SET_QUERY';
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS';
export const SET_FILTER2_OPTIONS = 'SET_FILTER2_OPTIONS';
export const SET_SORT_OPTIONS = 'SET_SORT_OPTIONS';
export const SET_SORT_ORDER_OPTIONS = 'SET_SORT_ORDER_OPTIONS';
export const SET_SEARCH_PLACEHOLDER_TEXT = 'SET_SEARCH_PLACEHOLDER_TEXT';

export function setQuery(query){
    return{
        type: SET_QUERY,
        payload: query
    };
}

export function setFilterOptions(filterOptions){
    return{
        type: SET_FILTER_OPTIONS,
        payload: filterOptions
            
    };
}

export function setFilter2Options(filter2Options){
    return{
        type: SET_FILTER2_OPTIONS,
        payload: filter2Options
    };
}

export function setSortOptions(sortOptions){
    return{
        type: SET_SORT_OPTIONS,
        payload: sortOptions
            
    };
}

export function setSortOrderOptions(sortOrderOptions){
    return{
        type: SET_SORT_ORDER_OPTIONS,
        payload:  sortOrderOptions
            
    };
}

export function setSearchPlaceholderText(placeholderText){
    return { 
        type: SET_SEARCH_PLACEHOLDER_TEXT,
        payload: placeholderText
    };
}